module.exports = __webpack_public_path__ + "img/campaign-dashboard.19b61ff7.svg";